import { IReview } from '@/src/interfaces/generated/contentful';
import { PageSection } from '@/src/packages/components/ui/PageSection';
import { PageSectionTitle } from '@/src/packages/components/ui/PageSection/PageSectionTitle';
import { TestimonialsList } from '@/src/packages/components/ui/TestimonialsList';

export const ProductReviews = ({ reviews }: { reviews: IReview[] }) => {
  return (
    <PageSection>
      <PageSectionTitle>Reviews</PageSectionTitle>
      <TestimonialsList reviews={reviews} itemsPerPage={4} />
    </PageSection>
  );
};
